import React from "react";
import { useTranslate } from 'react-redux-multilingual';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Style import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagic } from '@fortawesome/free-solid-svg-icons';

const  CustomizeInterfaceBtn = (props) => {
    const t = useTranslate();

    const handleClick = () => {
        props.setShow(true)
    }

    return (
        <OverlayTrigger
            placement="bottom"
            overlay={
                <Tooltip id={`tooltip-${props.index}`}>
                    {t('customizeInterface')}
                </Tooltip>
            }
        >
        <span onClick={() => handleClick()} style={{cursor:'Pointer',color:'#7F37A7'}}><FontAwesomeIcon icon={faMagic} /></span>
        </OverlayTrigger>  
    )
}

export default CustomizeInterfaceBtn;